<div class="sidebar-overlay" [ngClass]="{'active': showShoppingCart}">
</div>
<div #sidebar class="sidebar" [ngClass]="{'active': showShoppingCart}">
  <div class="sidebar-container p-3 row">
    <button mat-icon-button class="btn-close" (click)="toggleShow()"><mat-icon>close</mat-icon></button>
    <h2>Mi carrito</h2>

    <ng-container *ngIf="currentCart.length > 0; else currentCartHasNoItems">
      <div class="products-container position-relative">
        <div class="product card mb-3 border-0" *ngFor="let itemCart of currentCart; index as i">
          <div class="row g-0 h-100 align-items-center">
            <div class="col-md-4" style="height: 140px;">
              <img style="object-fit: contain;" class="img-fluid rounded" [src]="getItemImage(itemCart.item.images, itemCart.item)" [alt]="itemCart.item.name">
            </div>

            <div class="col-md-8 h-100">
              <div class="card-body d-flex align-items-md-start flex-column h-100">
                <p class="card-title fs-md"><strong>{{itemCart.item.name}}</strong></p>
                <div *ngIf="isProduct(itemCart.item) && !isAccesoryProductType(itemCart.item) && !isSetupProduct(itemCart.item)">
                  <p class="text-muted">Servicios Adicionales:</p>
                  <p [hidden]="!itemCart.item.additionalServices?.addDentalMonitoring">Dental Monitoring <u>{{itemCart.item.itemPrices.priceExtraDentalMonitoring | currency}}</u></p>
                  <p [hidden]="!itemCart.item.additionalServices?.addIsComplexCase">Caso Complejo <u>{{itemCart.item.itemPrices.priceComplexCase | currency}}</u></p>
                  <p>
                    <ng-container *ngIf="itemCart.item.hasUnlimitedAligners; else hasNotUnlimitedAligners">
                      <span>¡Este producto tiene alineadores ilimitados!</span>
                    </ng-container>
                    <ng-template #hasNotUnlimitedAligners>
                      <span [hidden]="itemCart.item.additionalServices?.extraAlignersQuantity == 0">{{itemCart.item.additionalServices.extraAlignersQuantity}} Alineadores Extra <u>{{itemCart.item.additionalServices.extraAlignersQuantity * itemCart.item.itemPrices.priceExtraAligner | currency}}</u></span>
                    </ng-template>
                  </p>
                </div>
                <div class="d-flex gap-2 align-items-center">
                  <app-custom-input-number #customInputQuantity
                    [minValue]="1"
                    [counter]="itemCart.quantity"
                    (valueChanged)="onUpdateQuantityItem(i, $event)"
                    [disabled]="isDisabledItemQuantityChange(itemCart.item)"
                  ></app-custom-input-number>
                  <button mat-icon-button class="btn-delete" (click)="onRemoveItem(i)"><i class="fa fa-trash-o" id="btn-delete-product-shopping-cart"></i></button>
                </div>
                <p class="w-100 text-end mt-md-auto" [ngClass]="{'text-decoration-line-through': itemCart.item.itemPrices.shoppingDiscount != null}">{{itemCart.item.itemPrices.price | currency}}</p>
                <p class="w-100 text-danger text-end" *ngIf="itemCart.item.itemPrices.shoppingDiscount != null">{{itemCart.item?.itemPrices.priceWithDiscount | currency}}</p>
              </div>
            </div>
          </div>
        </div>
        <mat-divider class="w-75"></mat-divider>
      </div>
      <div class="mt-md-auto d-flex flex-column justify-content-end align-items-end">
        <p class="description-case text-muted mt-2"><strong>
          <i class="fa fa-info-circle"></i>
          <ng-container *ngIf="getCaseId; else hasNotCaseId">
            Estos productos serán asignados al caso de: {{getCasePatientName}}
          </ng-container>
          <ng-template #hasNotCaseId>
            ¡Estos productos no se encuentran asignados a ningún caso!
          </ng-template>
        </strong></p>

        <div class="p-2 rounded w-100 text-end mt-4">
          <p>Subtotal: {{getSubtotal | currency}}</p>
          <p>IVA: {{getTax | currency}}</p>
          <p>Total: {{getTotal | currency}}</p>
          <button mat-button (click)="onProcessPurchase()" class="button secondary-button lh-1 p-2 mt-2">Procesar compra <mat-icon>chevron_right</mat-icon></button>
        </div>
      </div>
    </ng-container>

    <ng-template #currentCartHasNoItems>
      <div class="d-flex flex-column gap-2">
        <p class="fs-md"><strong>Aún no tienes productos o servicios agregados al carrito</strong></p>
        <p>Ve a la tienda y revisa el catalogo de paquetes y productos que ofrece Aliwell<sup>&#174;</sup></p>
        <mat-icon class="mx-auto shopping-cart-icon">shopping_cart</mat-icon>
        <button class="button secondary-button mt-auto" (click)="onGoStore()">Seguir comprando</button>
      </div>
    </ng-template>
  </div>
</div>
